import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  data: function data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        absentNumber: 0,
        actualNumber: 0,
        attendanceTime: null,
        lateNumber: 0,
        sickNumber: 0,
        status: 0,
        totalNumber: 0,
        type: ""
      },
      studentName: "",
      studentList: [],
      loading: false,
      searchObj: {
        userName: ""
      },
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        courseName: ""
      },
      total: 0
    };
  },
  created: function created() {
    this.getAttendance();
    this.getAttendancePage();
  },
  methods: {
    initPage: function initPage() {
      this.getAttendancePage();
    },
    getAttendance: function getAttendance() {
      var _this = this;

      var _JSON$parse = JSON.parse(this.$route.query.info),
          day = _JSON$parse.day,
          pkteachclassid = _JSON$parse.pkteachclassid,
          timeType = _JSON$parse.timeType,
          week = _JSON$parse.week,
          termid = _JSON$parse.termid;

      api.selectAttendanceDetails({
        day: day,
        pkteachclassid: pkteachclassid,
        semesterId: termid,
        timeType: timeType,
        week: week
      }).then(function (res) {
        _this.loading = false;

        if (res.data.code == 0) {
          _this.formLabelAlign = res.data.data;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    getAttendancePage: function getAttendancePage() {
      var _this2 = this;

      var _JSON$parse2 = JSON.parse(this.$route.query.info),
          day = _JSON$parse2.day,
          pkteachclassid = _JSON$parse2.pkteachclassid,
          timeType = _JSON$parse2.timeType,
          week = _JSON$parse2.week,
          termid = _JSON$parse2.termid;

      api.selectPCAttendanceStuPage({
        current: this.paramSearch.current,
        size: this.paramSearch.size,
        name: this.studentName,
        day: day,
        pkteachclassid: pkteachclassid,
        semesterId: termid,
        timeType: timeType,
        week: week
      }).then(function (res) {
        _this2.loading = false;

        if (res.data.code == 0) {
          _this2.studentList = res.data.data.records || [];
          _this2.total = res.data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    setStatus: function setStatus(item, status) {
      var _this3 = this;

      var curStatus = this.statusFormat(status);
      this.$confirm("\u5C06".concat(item.name, "\u7684\u7B7E\u5230\u72B6\u6001\u8BBE\u7F6E\u4E3A").concat(curStatus, "?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var _JSON$parse3 = JSON.parse(_this3.$route.query.info),
            day = _JSON$parse3.day,
            knob = _JSON$parse3.knob,
            pkteachclassid = _JSON$parse3.pkteachclassid,
            termid = _JSON$parse3.termid,
            timeType = _JSON$parse3.timeType,
            week = _JSON$parse3.week;

        var attendanceTime = item.attendanceTime,
            className = item.className,
            name = item.name,
            id = item.id,
            userNumber = item.userNumber;
        api.setClassOverviewPC({
          day: day,
          knob: knob,
          pkteachclassid: pkteachclassid,
          student: {
            attendanceTime: attendanceTime,
            className: className,
            id: id,
            name: name,
            status: status,
            userNumber: userNumber
          },
          termid: termid,
          timeType: timeType,
          week: week
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.code == 0) {
            _this3.getAttendancePage();

            _this3.$message.success(data.data);
          } else {
            _this3.$message.error(data.msg);
          }
        });
      }).catch(function () {});
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getAttendancePage();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getAttendancePage();
    },
    statusFormat: function statusFormat(status) {
      switch (status) {
        case "1":
          return "正常";

        case "2":
          return "迟到";

        case "3":
          return "早退";

        case "4":
          return "缺勤";

        case "5":
          return "补卡待审核";

        default:
          return "";
      }
    },
    cellStyle: function cellStyle(_ref2) {
      var row = _ref2.row,
          columnIndex = _ref2.columnIndex;

      if (row.status == "1" && columnIndex == 4) {
        return "color: #8FA9F2";
      } else if (row.status == "2" && columnIndex == 4) {
        return "color: #EC5F59";
      } else if (row.status == "3" && columnIndex == 4) {
        return "color: #333";
      } else if (row.status == "4" && columnIndex == 4) {
        return "color: #DBAC51";
      }
    }
  }
};